var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Notification',{staticClass:"notification-preview-container",attrs:{"titleArr":_vm.titleArr,"allowArchive":false,"notification":_vm.notification,"takeActionTitle":_vm.takeActionTitle},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }